var render = function render(){var _vm=this,_c=_vm._self._c;return _c('h4',{staticClass:"group-title"},[_vm._v(" "+_vm._s(' OA code / OA Vendor Name ' + _vm.groupCodeDesc))])
}
var staticRenderFns = []

export { render, staticRenderFns }